import { render, staticRenderFns } from "./DynamicInputs.vue?vue&type=template&id=9ac0a7e4"
import script from "./DynamicInputs.vue?vue&type=script&lang=js"
export * from "./DynamicInputs.vue?vue&type=script&lang=js"
import style0 from "./DynamicInputs.vue?vue&type=style&index=0&id=9ac0a7e4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports